// modules
import React, { PureComponent } from 'react';
import { head, tail } from 'ramda';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Link from 'components/Link';
import Job from 'components/Job';
import { formatRange } from 'utils/date';

// local
import styles from './Jobs.pcss';

export default class Jobs extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
    company: PropTypes.shape({
      
    }),
    jobs: PropTypes.arrayOf(
      PropTypes.shape({
        company: PropTypes.string,
        dates: PropTypes.arrayOf(PropTypes.string),
        description: PropTypes.arrayOf(PropTypes.node),
        location: PropTypes.string,
        title: PropTypes.string,
      })
    ),
  }
  static defaultProps = {
    company: {},
    jobs: {},
  }
  
  description(job) {
    const { description } = job;
    if (!description || !description.length) return null;
    
    return (
      <ul className={ styles.description }>
        {
          description.map((desc, i) => (
            <li key={ i }>{ desc }</li>
          ))
        }
      </ul>
    );
  }
  
  heading(job) {
    const { company } = this.props;
    const { title, dates } = job;
    return (
      <div className={ styles.heading }>
        <p className={ styles.title }>{ title }</p>
        <Link className={ styles.company } to={ company.website }>{ company.name }</Link>
        <p className={ styles.dates }>{ formatRange(dates) }</p>
      </div>
    );
  }
  
  get icon() {
    const { company } = this.props;
    const backgroundImage = `url("${ company.logo }")`;
    return (
      <Link
        className={ styles.icon }
        to={ company.website }
        style={{ backgroundImage }} />
    );
  }
  
  get pastRoles() {
    const { jobs } = this.props;
    if (!jobs || jobs.length < 2) return null;
    return (
      <div className={ styles.pastRoles }>
        {
          tail(jobs).map(job => (
            <div className={ styles.pastRole } key={ job.slug }>
              <span className={ styles.title }>{ job.title }</span>
              <p className={ styles.date }>{ formatRange(job.dates) }</p>
            </div>
          ))
        }
      </div>
    );
  }
  
  render() {
    const { className, company, jobs } = this.props;
    
    const classes = classnames(className, styles.jobs);
    
    const job = head(jobs);
    
    return (
      <div className={ classes }>
        <Job company={ company } job={ job }  />
        { this.pastRoles }
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/Jobs/index.jsx